module.exports = __webpack_public_path__ + "static/media/sow-section-3-administration.c2105f26.svg";